import { axios } from '@/utils/request'

// 首页班级动态
export function getDynamicListAll (queryParam) {
  return axios({
    url: '/dynamic/limitList',
    method: 'get',
    params: queryParam
  })
}

export function getCourseList (queryParam) {
  return axios({
    url: '/increaseCulum/recommend',
    method: 'get',
    params: queryParam
  })
}

export function getAbilityList (queryParam) {
  return axios({
    url: '/ability/list',
    method: 'get',
    params: queryParam
  })
}

export function getRankList (queryParam) {
  return axios({
    url: '/rank/list',
    method: 'get',
    params: queryParam
  })
}

// 获取学生班级
export function getClass (queryParam) {
  return axios({
    url: '/studentManage/getClass',
    method: 'get',
    params: queryParam
  })
}

// 验证该班级码是否存在
export function getClassInfo (queryParam) {
  return axios({
    url: '/Class/list',
    method: 'get',
    params: queryParam
  })
}
// 班级码存在，提交班级码，修改为待审核状态
export function putObjClass (obj) {
  return axios({
    url: '/studentManage',
    method: 'put',
    data: obj
  })
}
// 撤回审核中班级或者退出已加入班级
export function removeClass (studentId) {
  return axios({
    url: '/Class/remove?studentId=' + studentId,
    method: 'put',
    data: studentId
  })
}
// 加入云学谷班级
export function YunxueguClass (queryParam) {
  return axios({
    url: '/Class/addYunxuegu',
    method: 'put',
    params: queryParam
  })
}
